import { createContext } from "react";
import { Capability, PERMISSION, ROLE } from "./types";

interface AuthorizationContext {
  capabilities: Capability;
  roles: string[];
  hasPermission(permission: PERMISSION): boolean;
  hasRole(role: ROLE): boolean;
  loaded: boolean;
  id: string | null;
  universityLegacyIds: string[];
  sectionLegacyIds: string[];
  sectionLegacyIdsLoading: boolean;
  hasUniversityAccess(universityLegacyId: string): boolean;
}

export const DEFAULT_CAPABILITIES: Capability = { domains: [], permissions: [] };

const defaultContext = {
  capabilities: DEFAULT_CAPABILITIES,
  roles: [],
  hasPermission(_: PERMISSION) {
    return false;
  },
  hasRole(_: ROLE) {
    return false;
  },
  loaded: false,
  id: null,
  universityLegacyIds: [],
  sectionLegacyIds: [],
  sectionLegacyIdsLoading: false,
  hasUniversityAccess(_: string) {
    return false;
  }
};

export const AuthorizationContext = createContext<AuthorizationContext>(defaultContext);
